module.exports = __webpack_public_path__ + "img/cdztu.ed3614f5.png";